<table>
    <thead>
      <tr>
        <th class="subtable string">{{'usuarios.productor.table.tabs.huertos.marcas.marca' | translate}}</th>
        <th class="subtable number">{{'usuarios.productor.table.tabs.huertos.marcas.aforo' | translate}}</th>
        <th class="subtable number">{{'usuarios.productor.table.tabs.huertos.marcas.porcentaje' | translate}}</th>
      </tr>
    </thead>
    <tbody *ngFor="let huerto of marcasHuertosList">
      <tr>
        <td class="string">{{huerto.desMarca}}</td>
        <td class="number">{{huerto.aforo}}</td>
        <td class="number">{{(huerto.aforo/huerto.aforoCultivo) * 100 | number : '.2' : defaultLanguage}}</td>
      </tr>
    </tbody>
    <tfoot *ngIf="!marcasHuertosList || (marcasHuertosList && marcasHuertosList.length < 1)">
      <tr>
        <td colspan="3">
          {{'global.noContent' | translate}}
        </td>
      </tr>
    </tfoot>
  </table>
  <!-- <app-paginator *ngIf="marcasHuertosList && marcasHuertosList.length > 0" [itemsPerPage]="itemsPerPage"
    [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
    (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
  </app-paginator> -->
  